







































import { Component, Vue } from 'vue-property-decorator'
import Swal from 'sweetalert2'
import { SHA256 } from 'crypto-js'
import axiosInstance from '@/plugins/axios'

@Component
export default class Login extends Vue {
  username = ''
  password = ''
  isLoading = false

  async login (): Promise<void> {
    try {
      this.isLoading = true

      const res = await axiosInstance.post('/user/login', {
        username: this.username,
        password: SHA256(this.password + 'RandomTreePeople12!@').toString()
      })

      const data: any = res.data
      console.info('LOGIN_RESULT', data)

      if (data.result === 'INCORRECT_USERNAME_PASSWORD') {
        this.isLoading = false
        Swal.fire({
          icon: 'error',
          title: 'ຊື່ຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ'
        })
        return
      }

      localStorage.setItem('SCPPORTAL_ACCESS_TOKEN', data.jwt)
      await this.$store.dispatch('user/setCurrentUser', {
        username: data.username,
        name: data.name,
        phone: data.phone,
        roles: data.roles
      })

      await this.$router.push('/products')
      this.isLoading = false
    } catch (error) {
      console.error(error)
      this.isLoading = false
      Swal.fire({
        icon: 'error',
        title: 'ກະລຸນາລອງໃໝ່ອີກຄັ້ງ'
      })
    }
  }
}
